import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ListGuide__guide"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 你的队伍共赚")
const _hoisted_3 = { class: "ListGuide__highlight" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ，排名")
const _hoisted_5 = { class: "ListGuide__highlight" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("，继续努力～ ")
const _hoisted_7 = {
  key: 1,
  class: "ListGuide__guide"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ListGuide__highlight" }, "2人", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("即可组队，最多赚")
const _hoisted_10 = { class: "ListGuide__highlight" }

import RankTeam from '@/components/RankTeam.vue';
import { useStore } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const maxKkbCanObtain = computed(() => store.state.rule.maxKkbCanObtain);
const myTeamRank = computed(() =>
  store.state.myTeamRank.rank > 99
    ? '99+'
    : `第${store.state.myTeamRank.rank}名`
);
const showMyTeam = computed(() => store.state.myTeamRank.rank > 20);
const myRank = computed(() => store.state.myTeamRank.rank);
const myTeanInfo = computed(() => {
  return {
    name: store.state.myTeamRank.name,
    totalInfo: store.state.myTeamRank.totalInfo,
    expansionInfo: '',
    leaderObtainInfo: '',
    leaderImg: `${store.state.avatarHost}${store.state.myTeamRank.leaderImg}`,
  };
});
const hasRank = computed(() => store.state.myTeamRank.rank > 0);
const teamObtain = computed(() => store.state.myTeamRank.total);
const ranks = computed(() => {
  const result = store.state.teamRanks.map((team) => ({
    name: team.name,
    totalInfo: team.totalInfo,
    expansionInfo: team.expansionInfo,
    leaderObtainInfo: team.leaderObtainInfo,
    leaderImg: team.leaderImg ? `${store.state.avatarHost}${team.leaderImg}`: 'https://f2.kkmh.com/default_avatar_image.jpg-w180',
  }));
  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(hasRank))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(teamObtain)) + "KK币", 1),
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(myTeamRank)), 1),
          _hoisted_6
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(maxKkbCanObtain)) + "KK币", 1)
        ])),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ranks), (team, rank) => {
      return (_openBlock(), _createBlock(RankTeam, {
        key: rank,
        rank: rank + 1,
        options: team
      }, null, 8, ["rank", "options"]))
    }), 128)),
    (_unref(showMyTeam))
      ? (_openBlock(), _createBlock(RankTeam, {
          key: 2,
          rank: _unref(myRank),
          options: _unref(myTeanInfo)
        }, null, 8, ["rank", "options"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})